import * as types from './types'

export default {
    [types.ENUM_LIST](state: { enumList: any }, data: any) {
        state.enumList = data
    },
    [types.CHANGE_ASSIGN](state: { changeAssign: any }, data: any) {
        
        state.changeAssign = data
    },
}
